import { render, staticRenderFns } from "./ErrorToasts.vue?vue&type=template&id=32bdbb54"
import script from "./ErrorToasts.vue?vue&type=script&lang=ts"
export * from "./ErrorToasts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.9_css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_p_rtqrtxx4ab5lun7j52al72xaei/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32bdbb54')) {
      api.createRecord('32bdbb54', component.options)
    } else {
      api.reload('32bdbb54', component.options)
    }
    module.hot.accept("./ErrorToasts.vue?vue&type=template&id=32bdbb54", function () {
      api.rerender('32bdbb54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ErrorToasts.vue"
export default component.exports